import { ProfileChapter } from '@/features/profile-page/ProfileChapter/ui/ProfileChapter'
import './ui/ProfileChapter.css'
export default ProfileChapter
